module.exports = __webpack_public_path__ + "static/media/food-5.c53dd95c.jpg";